module.exports = __webpack_public_path__ + "static/media/pen.b40b2673.svg";